<template>
    <div class="clearfix">
        <a-upload v-model:file-list="fileList" :maxCount="maxCount" list-type="picture" @preview="handlePreview"
            @remove="handleRemove" :before-upload="beforeUpload" :disabled="disabled">
            <div>
                <plus-outlined />
                <!-- <div style="margin-top: 8px">Upload</div> -->
            </div>
        </a-upload>
        <a-modal :open="previewVisible" :title="previewTitle" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>
<script lang="ts" setup>
import { PlusOutlined } from '@ant-design/icons-vue';
import { ref, watch } from 'vue';
import type { UploadProps } from 'ant-design-vue';
import { cloneDeep } from "lodash-es"
const props = defineProps({
    maxCount: {
        type: Number,
        default: 1
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const emits = defineEmits(["file-change"])

function getBase64(file: File) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');

const fileList = ref<UploadProps['fileList']>([
]);

watch(() => fileList.value, async (Val) => {
    const tempFile = []
    if (Val) {
        for (let i = 0; i < Val.length; i++) {
            //@ts-ignore
            const temp = await getBase64(Val[i])
            //@ts-ignore
            const tempBase = temp.split(",")
            if (tempBase.length > 1) {
                const copy = cloneDeep(tempBase[1])
                //@ts-ignore
                tempFile.push(copy)
            }
        }
    }
    emits("file-change", tempFile)
})

const handleCancel = () => {
    previewVisible.value = false;
    previewTitle.value = '';
};
//@ts-ignore
const handlePreview = async (file: UploadProps['fileList'][number]) => {
    if (!file.url && !file.preview) {
        file.preview = (await getBase64(file.originFileObj)) as string;
    }
    previewImage.value = file.url || file.preview;
    previewVisible.value = true;
    previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};

const beforeUpload: UploadProps['beforeUpload'] = file => {
    fileList.value = [...(fileList.value || []), file];
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const img: HTMLImageElement = document.createElement('img');
            img.src = reader.result as string;
            // emits("file-change", reader.result)

        }
    })


};

const handleRemove: UploadProps['onRemove'] = file => {
    //@ts-ignore
    const index = fileList.value.indexOf(file);
    //@ts-ignore
    const newFileList = fileList.value.slice();
    newFileList.splice(index, 1);
    fileList.value = newFileList;
    // return new Promise(resolve => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //         const img: HTMLImageElement = document.createElement('img');
    //         img.src = reader.result as string;
    //         emits("file-change", reader.result)
    //     }
    // })

};
</script>
<style scoped>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>